<script setup lang="ts">
import { PaymentPage } from '@/types/api/api-v3/payment'

type Props = {
  page: PaymentPage
}
const props = defineProps<Props>()

const attentionsList = computed(() => {
  const attentions: string[] = []

  if (props.page?.required_1) attentions.push(props.page.required_1)
  if (props.page?.required_2) attentions.push(props.page.required_2)

  return attentions
})
</script>

<template>
  <ul class="payment-attentions">
    <li
      v-for="(attention, index) in attentionsList"
      :key="index"
      class="payment-attentions__item"
    >
      <div
        class="payment-attentions__icons"
        :class="{
          'payment-attentions__icons--duo': attentionsList.length === 2,
        }"
      >
        <nuxt-img
          v-for="iconIndex in index + 1"
          :key="iconIndex"
          src="/star.svg"
          width="20"
          height="20"
        />
      </div>
      <span class="payment-attentions__text">{{ attention }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.payment-attentions {
  list-style-type: none;
  @include media('>=desktop-mini') {
    display: flex;
    gap: 70px;
  }

  &__item {
    display: flex;
    align-items: baseline;
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    @include media('>=desktop-mini') {
      flex-basis: 50%;
      align-items: flex-start;
      max-width: 50%;
      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }

  &__icons {
    display: flex;
    flex-shrink: 0;
    gap: 5px;
    width: 20px;
    margin-right: 15px;
    white-space: nowrap;
    &--duo {
      width: 45px;
    }
    @include media('>=desktop-mini') {
      width: auto;
    }
  }

  &__text {
    font-size: 12px;
    font-weight: 600;
    color: $text-light;
  }
}
</style>
